import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import apiDescription from '../../kiota/api-description.json';

@Injectable({
    providedIn: 'root',
})
export class VersionService {
    constructor(private http: HttpClient) {
        this.getAppVersion();
    }

    public getAppVersion() {
        this.http.get('CHANGELOG.md', { responseType: 'text' }).subscribe((data) => {
            this.appVersion = this.getVersionFromChangelog(data);
        });
    }

    public appVersion = '';
    public apiVersion: string = apiDescription.info.version;

    /**
     * Estrae la versione dalla prima riga del contenuto di un file changelog.
     * @param changelog Contenuto testuale del file da cui estrarre la versione
     * @returns La versione (ad es. "1.0.0") o stringa vuota se non trovata
     */
    getVersionFromChangelog(changelog: string): string {
        // La regex cerca, all'inizio della riga, uno o più '#' seguiti da spazi e poi il numero di versione racchiuso tra parentesi quadre.
        const regex = /^\s*#{1,}\s*\[([0-9]+\.[0-9]+\.[0-9]+)\]/m;
        const match = changelog.match(regex);
        return match ? match[1].trim() : '';
    }
}
